// extracted by mini-css-extract-plugin
export default {"menuBlock":"rE-z","title":"sE-z","nav":"tE-z","flexCell":"uE-z","facetLink":"vE-z"};